export const DrAdminSections = {
    TeamMembers: "Team Members",
    Intake: "Intake Requirements"
};